<template>
  <pnet-validation-observer>
    <div>
      <div v-if="label" class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for>
              <small>{{label}}</small>
            </label>
            <pnet-multiselect
              v-model="option"
              @input="changedValue"
              :name="label"
              :rules="{required:isRequired}"
              :customMessages="{required:'Il campo deve essere valorizzato.'}"
              :options="options"
              label="description"
              trackBy="code"
              :multiple="true"
              :taggable="true"
              placeholder="Scegli una o più opzioni"
              selectLabel="Clicca o premi invio per selezionare"
              deselectLabel="Clicca o premi invio per rimuovere"
              selectedLabel="Selezionato"
              :sortTags="true"
              :sortOptions="true"
              sortOptionsKey="code"
              :customSort="compareOptions"
            >
            </pnet-multiselect>
          </div>
        </div>
      </div>

      <pnet-multiselect
        v-if="!label"
        v-model="option"
        @input="changedValue"
        :rules="{required:isRequired}"
        :options="options"
        label="description"
        trackBy="code"
        :multiple="true"
        :taggable="true"
        placeholder="Scelgi una o più opzioni"
        selectLabel="Clicca o premi invio per selezionare"
        deselectLabel="Clicca o premi invio per rimuovere"
        selectedLabel="Selezionato"
        :sortTags="true"
        :sortOptions="true"
        sortOptionsKey="code"
        :customSort="compareOptions"
      >
      </pnet-multiselect>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import { PnetMultiselect } from '@previnet/vue-multiselect';

export default Vue.extend({
  props: ["label", "value", "options", "handlerOnChange", "required", "descCompare"],
  components:{
    PnetMultiselect,
  },
  data() {
    return {
      option: [],
      isRequired: true,
      rawSortField: null,
    }
  },
  mounted() {
    this.option = this.value;
    if (this.required !== undefined) {
      this.isRequired = this.required;
    }
  },
  methods: {
    changedValue: function(e) {
      this.$emit('input',this.option.sort(this.compareOutput));
      if (this.handlerOnChange){
        this.handlerOnChange()
      }

    },
    compareOutput: function(a, b) {
      if (this.descCompare) {
        const aDesc = a.description.toUpperCase();
        const bDesc = b.description.toUpperCase();

        return this._descCompare(aDesc, bDesc);
      } else {
        const aCode = a.code;
        const bCode = b.code;

        return this._compare(aCode, bCode);
      }
    },
    compareOptions: function(a, b) {
      if (this.descCompare) {
        const aDesc = a.obj.description.toUpperCase();
        const bDesc = b.obj.description.toUpperCase();

        return this._descCompare(aDesc, bDesc);
      } else {
        const aCode = a.obj.code;
        const bCode = b.obj.code;

        return this._compare(aCode, bCode);
      }
    },
    _compare: function(aCode, bCode) {
      if (aCode === undefined || bCode === undefined) {
        if (bCode !== undefined) {
          return -1;
        }
        if (aCode !== undefined) {
          return 1;
        }
        return 0;
      }

      let aSplit = aCode.split(".");
      let bSplit = bCode.split(".");
      if (aSplit.length > 1 && bSplit.length > 1) {
        let aPre = parseInt(aSplit[0]);
        let aPost = parseInt(aSplit[1]);
  
        let bPre = parseInt(bSplit[0]);
        let bPost = parseInt(bSplit[1]);

        if (aPre == bPre) {
          if (aPost < bPost) {
            return -1;
          }
          if (aPost > bPost) {
            return 1;
          }
          return 0;
        } else if (aPre < bPre) {
          return -1;
        } else {
          return 1;
        }
      }

      if (aCode < bCode) {
        return -1;
      }
      if (aCode > bCode) {
        return 1;
      }
      return 0;
    },
    _descCompare: function(aDesc, bDesc) {
      if (aDesc === undefined || bDesc === undefined) {
        if (bDesc !== undefined) {
          return -1;
        }
        if (aDesc !== undefined) {
          return 1;
        }
        return 0;
      }

      if (aDesc < bDesc) {
        return -1;
      }
      if (aDesc > bDesc) {
        return 1;
      }
      return 0;
    }
  },
  watch: {
    value: {
      deep: true,      
      handler() {
        this.option = this.value;
        if (this.required !== undefined) {
          this.isRequired = this.required;
        }
      }
    }
  }
});
</script>
